import { useState, useEffect } from "react";

import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";

import { Button, Stack } from "@mui/material";

import { ArrowBack } from "@mui/icons-material";

import WithdrawnAuthorization from "./WithdrawnAuthorization";
import withdrawnAuthorizationService from "../../../services/withdrawnAuthorizationService";
import { WithdrawnAuthorizationPreviewDto } from "../../../interfaces/WithdrawnAuthorization";
import HistoryLog from "../../shared/HistoryLog";
import PrintFooter from "../../../common/components/PrintFooter";
import { PublicRoutesConfig, CommonRoutesConfig } from "../../RoutesConfig";
import usePrint from "../../../common/hooks/usePrint";

export default function Preview() {
  const { id: paramsId } = useParams();
  const withdrawnAuthorizationId: number = parseInt(paramsId as string);
  const navigate = useNavigate();
  const [withdrawnAuthorization, setWithdrawnAuthorization] = useState<WithdrawnAuthorizationPreviewDto>();
  const { printComponentRef, print } = usePrint();

  useEffect(() => {
    if (isNaN(withdrawnAuthorizationId)) {
      navigate(CommonRoutesConfig.NotFound.Path, { replace: true });
    }

    (async () => {
      await withdrawnAuthorizationService
        .getWithdrawnAuthorizationAsync(withdrawnAuthorizationId)
        .then(({ data }) => setWithdrawnAuthorization(data));
    })();
  }, []);

  const renderPrintTemplate = () => (
    <div style={{ display: "none" }}>
      <Stack spacing={3} ref={printComponentRef}>
        <WithdrawnAuthorization model={withdrawnAuthorization} />
        <PrintFooter />
      </Stack>
    </div>
  );

  const renderPreview = () => (
    <Stack spacing={3}>
      <Stack direction="row" justifyContent="space-between">
        <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)}>
          Назад
        </Button>
        <Stack direction="row" spacing={1}>
          <Button startIcon={PublicRoutesConfig.WithdrawnAuthorization.Print.Icon} onClick={print}>
            {PublicRoutesConfig.WithdrawnAuthorization.Print.Label}
          </Button>
        </Stack>
      </Stack>
      <WithdrawnAuthorization model={withdrawnAuthorization} />
      <HistoryLog
        logs={withdrawnAuthorization?.historyLogs}
        path={PublicRoutesConfig.WithdrawnAuthorization.HistoryPreview.Path}
      />
    </Stack>
  );

  return (
    <>
      {renderPreview()}
      {renderPrintTemplate()}
    </>
  );
}
